import { css } from "styled-components";
import { BladeContent } from "../../../../components/BladeContent";
import { BladeHeaderTitle } from "../../../../components/BladeHeader";
export const riotProductSkin = (chroma, palette) => css `
  padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};

  ${BladeContent} {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  ${BladeHeaderTitle} {
    ${chroma.typography.display6};
    color: ${palette.bladetext1};
    font-weight: bold;
    font-style: italic;
  }

  .ability-icon {
    width: 64px;
    height: 64px;
    border-radius: 32px;

    ${chroma.mediaQueries.mobileDown} {
      width: 48px;
      height: 48px;
      border-radius: 24px;
    }
  }

  .character-name {
    ${chroma.typography.body1};
    font-weight: bold;
    color: ${palette.bladetext1};
  }

  .character-changes-container {
    display: flex;
    flex-direction: column;
  }

  .character-change {
    display: flex;
    flex-direction: column;
    gap: 32px;
    border-top: 1px solid ${palette.keyline};
    padding: 32px 0;

    ${chroma.mediaQueries.mobileDown} {
      gap: 16px;
    }
  }

  .character-change-header {
    display: flex;
    align-items: center;
    gap: 24px;

    ${chroma.mediaQueries.mobileDown} {
      gap: 16px;
    }
  }

  .character-change-body * {
    ${chroma.typography.body3};
    color: ${palette.bladetext1};
  }

  .character-changes-details {
    padding: 32px;
    padding-bottom: 0;
    border: 1px solid ${palette.keyline};
    border-top: none;

    ${chroma.mediaQueries.mobileDown} {
      padding: 24px;
      padding-bottom: 0;
    }
  }

  .character-changes-summary {
    padding: 32px 0;

    ${chroma.mediaQueries.mobileDown} {
      padding-top: 24px;
    }
  }

  .character-ability-title {
    ${chroma.typography.body1};
    font-weight: bold;
    color: ${palette.bladetext1};
  }
`;
//# sourceMappingURL=index.js.map